import requests from "./httpService";

const CityDistanceServices = {

  addCity: async (body) => {
    return requests.post("/cityDistance/add", body);
  },
  getAllCity: async () => {
    return requests.get("/cityDistance");
  },
  getPeriodicHourlyCity: async (body) =>{
    return requests.get("/place/getCities/hourlyRental")
  },
  getPeriodicDailyCity: async (body) =>{
    return requests.get("/place/getCities/outstation")
  },
  getCityById: async (id, body) => {
    return requests.get(`/cityDistance/${id}`, body);
  },
  getCityByStateId:async (id,body) => {
    return requests.get(`/city/cityByState/${id}`, body);
  },

  updateCity: async (id, body) => {
    return requests.put(`/cityDistance/update/${id}`, body);
  },

  deleteCity: async (id) => {
    return requests.delete(`/cityDistance/delete/${id}`);
  },

  getCityDistance: async (body) => {
    return requests.post(`/cityDistance/getDistance`,body)
  }
 
};

export default CityDistanceServices;
